import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { BaseModalComponent } from '../base-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { formatDatetime } from 'util/date.utility';

@Component({
  selector: 'app-audit-entry-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './audit-entry-modal.component.html',
  styleUrl: './audit-entry-modal.component.scss'
})
export class AuditEntryModalComponent extends BaseModalComponent implements OnChanges {
  @Input() auditEntry!: any;
  @Input() isOpen: boolean = false;
  formatDateTime = formatDatetime;
  @ViewChild('content') content!: ElementRef;

  override ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (changes['isOpen'] && this.isOpen) {
      this.open(this.content);
    }
  }

  getChanges(): string {
    return this.jsonToHtmlFormatted(this.auditEntry.changes);
  }

  jsonToHtmlFormatted(json: any, indent: number = 0): string {
    const indentSize = 2;
    const space = (level: number) => '&nbsp;'.repeat(level * indentSize);
    let html = '';

    if (Array.isArray(json)) {
      html += '[<br>';
      for (let i = 0; i < json.length; i++) {
        html += space(indent + 1) + this.jsonToHtmlFormatted(json[i], indent + 1);
        if (i < json.length - 1) html += ',';
        html += '<br>';
      }
      html += space(indent) + ']';
    } else if (typeof json === 'object' && json !== null) {
      html += '{<br>';
      const keys = Object.keys(json);
      keys.forEach((key, index) => {
        const value = json[key];
        html += space(indent + 1) + `"${key}": ` + this.jsonToHtmlFormatted(value, indent + 1);
        if (index < keys.length - 1) html += ',';
        html += '<br>';
      });
      html += space(indent) + '}';
    } else if (typeof json === 'string') {
      html += `"${json}"`;
    } else {
      html += String(json);
    }

    return html;
  }
}
